import { useQuery } from '@apollo/client';

import LearnerProfileInferredCareerRolesQuery from 'bundles/onboarding-common/queries/LearnerProfileInferredCareerRoles.graphql';
import type {
  LearnerProfileInferredCareerRolesQuery as LearnerProfileInferredCareerRolesQueryType,
  LearnerProfileInferredCareerRolesQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerProfileInferredCareerRoles';
import type { RoleFragment } from 'bundles/onboarding-common/queries/__generated__/RoleFragment';

type UseGetMLInferredRoleReturn = {
  mlInferredRole: Pick<RoleFragment, 'id' | 'name'> | undefined;
  mlInferredRoleLoading: boolean;
};

const useGetMLInferredRole = ({ skip }: { skip: boolean }): UseGetMLInferredRoleReturn => {
  const { data, loading } = useQuery<
    LearnerProfileInferredCareerRolesQueryType,
    LearnerProfileInferredCareerRolesQueryVariables
  >(LearnerProfileInferredCareerRolesQuery, {
    context: {
      clientName: 'gatewayGql',
    },
    ssr: true,
    skip,
  });

  const highestConfidenceLevel = data?.LearnerProfile?.me?.inferredCareerRolesOfInterest?.[0]?.confidenceLevel;
  const topRankedInferredRole = data?.LearnerProfile?.me?.inferredCareerRolesOfInterest?.[0]?.role;
  const isHighOrMediumConfidenceLevel = highestConfidenceLevel === 'HIGH' || highestConfidenceLevel === 'MEDIUM';

  return {
    mlInferredRole: isHighOrMediumConfidenceLevel ? topRankedInferredRole : undefined,
    mlInferredRoleLoading: loading,
  };
};

export default useGetMLInferredRole;
